import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 border-t border-background-700/30">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-100">韩漫网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              韩漫网为您提供海量韩国漫画免费在线观看服务，支持下拉式阅读和高清画质，无需注册即可畅享全集内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">全部分类</Link>
              <Link to="/category/all?sort=hot" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热门排行</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">恋爱漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">奇幻漫画</Link>
              <Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">动作漫画</Link>
              <Link to="/category/thriller" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">悬疑漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2 text-sm text-foreground-400">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-foreground-400"></i>
                </div>
                <span>contact@dukesimage.cn</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-400">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-foreground-400"></i>
                </div>
                <span>客服QQ：1234567890</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 韩漫网 - 韩国漫画免费在线观看平台。本站所有内容均来自网络，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}